// extracted by mini-css-extract-plugin
export default {"orderHeader":"Locations_orderHeader__5w8Id","button":"Locations_button__OwLfR"};